export const chooseReportLabelListRND = [
  {
    value: "get_lender_loans_report_v2_detail",
    label: "Loan Account List v2 - Detail",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      {
        title: "Insurance Monitoring",
        field: "insurance_info",
        Cell: (props) => <img src={props?.value} alt="" />,
      },
      { title: "Investors Rate", field: "inv_rate_note_rate" },
      // { title: "Time to Maturity", field: "maturitydate" },
      { title: "Payoff Date", field: "maturitydate" },
    ],
  },
  {
    value: "get_lender_loans_report_v2",
    label: "Loan Account List v2",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      { title: "Maximum Principal Balance", field: "max", type: "number" },
    ],
  },
  {
    value: "report_lender_servicing_activity_summary2",
    label: "Lender-Loan Daily Activity Summary v2",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_servicing_activity_summary",
    label: "Lender-Loan Daily Activity Summary",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "draws_transactions_report",
    label: "Draws Transactions Report",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_distribution_remittance_detail2",
    label: "Lender Distribution Remittance Detail Report V2",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Include Pending",
        field: "include_pending",
        type: "radio",
        options: [
          { title: "No", value: 0 },
          { title: "Yes", value: 1 },
        ],
      },
    ],
  },
  {
    value: "report_p_and_i_transactions",
    label: "P & I Transaction Report",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_borrower_paystring2",
    label: "Borrower DQ Status - PayString Report",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      { title: "Maximum Principal Balance", field: "max", type: "number" },
      { title: "Months Back", field: "monthsback", type: "number" },
      {
        title: "Borrower Account Min",
        field: "borrower_account_min",
        type: "text",
        display: "hidden",
      },
      {
        title: "Borrower Account Max",
        field: "borrower_account_max",
        type: "text",
        display: "hidden",
      },
    ],
  },
  {
    value: "report_lender_distribution_remittance_detail",
    label: "Lender Distribution Remittance Detail Report",
    options: [
      {
        title: "Check Number",
        field: "check_number",
        type: "text",
        display: "hidden",
      },
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Include Pending",
        field: "include_pending",
        type: "radio",
        options: [
          { title: "No", value: 0 },
          { title: "Yes", value: 1 },
        ],
      },
    ],
  },
  {
    value: "report_borrower_payment_distribution_audit",
    label: "Borrower Payment Distribution Audit Report",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Borrower Account Min",
        field: "borrower_account_min",
        type: "text",
        display: "hidden",
      },
      {
        title: "Borrower Account Max",
        field: "borrower_account_max",
        type: "text",
        display: "hidden",
      },
    ],
  },
  {
    value: "report_borrower_delinquency_report",
    label: "Borrower Delinquency Report",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },

  {
    value: "report_Daily_Activity2",
    label: "Lender-Loan Daily Activity History",
    options: [
      { title: "Exclude Advances", field: "exclude_advances", type: "Number" },
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_Daily_Activity",
    label: "Advanced Date Filter Test 4",
    options: [
      { title: "Start Date", field: "startdate", type: "date" },
      { title: "End Date", field: "enddate", type: "date" },
      { title: "Exclude Advances", field: "exclude_advances", type: "Number" },
    ],
  },
  {
    value: "report_borrower_late_report2",
    label: "Borrower Late Report",
    options: [
      {
        title: "Exclude Borrowers On Hold",
        field: "excludeOnHold",
        type: "radio",
        options: [
          { title: "Yes", value: 1 },
          { title: "No", value: 0 },
        ],
      },
      {
        title: "Exclude Loans Within Grace Period",
        field: "excludeWithinGracePeriod",
        type: "radio",
        options: [
          { title: "Yes", value: 1 },
          { title: "No", value: 0 },
        ],
      },
    ],
  },
  {
    value: "report_wells_fargo",
    label: "Lender-Servicing Activity Summary",
    options: [
      { title: "Start Day", field: "startday", type: "number" },
      { title: "End Day", field: "endday", type: "number" },
      { title: "Months Back", field: "months_back", type: "Number" },
    ],
  },
  {
    value: "get_lender_loans_report",
    label: "Loan Account List",
    options: [
      {
        title: "Loan Status",
        field: "past",
        type: "radio",
        options: [
          { title: "Active", value: 0 },
          { title: "Paid Off", value: 1 },
          { title: "All", value: 2 },
        ],
      },
      { title: "Minimum Principal Balance", field: "min", type: "number" },
      { title: "Maximum Principal Balance", field: "max", type: "number" },
    ],
  },
  {
    value: "get_past_payments3",
    label: "Lender Past Payments",
    options: [],
  },
  {
    value: "report_loan_portfolio",
    label: "Portfolio Report",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_statement",
    label: "Lender Statement of Account",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
    ],
  },
  {
    value: "report_lender_loan_statement_details3",
    label: "Lender Loan Data - Weston Schema 202207",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      { title: "Category", field: "Category", type: "text" },
    ],
  },
  {
    value: "report_borrower_payment_summary",
    label: "Borrower Payment Summary Report",
    options: [
      {
        title: "Date Range",
        field: "date_range",
        type: "text",
        display: "hidden",
      },
      { title: "Start Date", field: "arg1", type: "date" },
      { title: "End Date", field: "arg2", type: "date" },
      { title: "Arg 3", field: "arg3", type: "text", display: "hidden" },
      {
        title: "Borrower Account Min",
        field: "borrower_account_min",
        type: "text",
        display: "hidden",
      },
      {
        title: "Borrower Account Max",
        field: "borrower_account_max",
        type: "text",
        display: "hidden",
      },
    ],
  },
];
export const reportGridColumn2RND = [
  {
    field: "Lender Account",
    title: "Loan Acc",
  },
  {
    field: "Original Balance",
    title: "Original Balance",
  },
  {
    field: "Current Balance",
    title: "Current Balance",
  },
  {
    field: "Loan Info",
    title: "Loan Info",
  },
  {
    field: "Next Due Dates",
    title: "Next Due Dates",
  },
  {
    field: "Lender Principal Investment",
    title: "Lender Principal Investment",
  },
  {
    field: "YTD Interest",
    title: "YTD Interest",
  },
  {
    field: "Time to Maturit",
    title: "Time to Maturit",
  },
  {
    field: "Term Left",
    title: "Term Left",
  },
  {
    field: "Maturity Date",
    title: "Maturity Date",
  },
  {
    field: "PStreet",
    title: "PStreet",
  },
  {
    field: "Pcity",
    title: "Pcity",
  },
  {
    field: "Pstate",
    title: "Pstate",
  },
  {
    field: "Pzipcode",
    title: "Pzipcode",
  },
  {
    field: "Property Address",
    title: "Property Address",
  },
  {
    field: "Borrower Name",
    title: "Borrower Name",
  },
  {
    field: "Days Late",
    title: "Days Late",
  },
  {
    field: "noterate",
    title: "noterate",
  },
  {
    field: "soldrate",
    title: "soldrate",
  },
];
export const intialStateRND = {
  past: 0,
  min: 1000,
  max: 10000000,
  monthsback: 0,
  borrower_account_min: "",
  borrower_account_max: "",
  date_range: "FP",
  arg1: "07/03/2021",
  arg2: "06/03/2023",
  arg3: "",
  check_number: "",
  include_pending: 0,
  lenderId: 0,
  exclude_advances: 0,
  startdate: 0,
  enddate: 0,
  excludeOnHold: 0,
  excludeWithinGracePeriod: 0,
  startday: 0,
  endday: 0,
  months_back: 0,
  Category: 0,
};
